/// <summary>
/// <br/>
/// Author: AFU<br />
/// Date: 20.1.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 4.6.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DashboardOnlineValue", jQuery.common.vcBaseV4, {

    myData: {
        item: {}
},
    //// Tracks the current UI/editing state:
    ////   - index: The array index of the currently selected/edited entry (-1 = new entry mode).
    ////   - decimals: The number of decimal places used for formatting online signal values.
    //myStatus: {
    //    index: -1,
    //    decimals: 3
    //},

    /**
     * Widget constructor. Registers this visual component with the framework
     * using type ID 407 (unique identifier for DailyPlausibility) and invokes
     * the parent class (vcBaseV4) constructor to set up inherited functionality.
     */
    _create: function () {
        this._createVisual(411);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-item-onlinevalue");
            me.myRoot.css("height", "100%");
           
            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

            // Calculate and apply element dimensions relative to the visual's total size.
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
   
    _initEvents: function () {
        var me = this;
        try {
            // Fetch signals first, then initialize the dashboard with the loaded data.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        var me = this;
        try {
            // Master reference object holding all DOM element references for easy access.
            me.myHtml = {};
            me.myHtml.wrapper = me._setObj("", "");
            me.myHtml.wrapper.css({ display: "flex", "align-items": "center", "justify-content": "center", width: "100%", height: me._getVisualHeight() + "px" });
            me.myHtml.wrapper.value = $("<span>").addClass('dashboard-online-value').html("---");
            me.myHtml.wrapper.unit = $("<span>").addClass('dashboard-online-unit').css("margin-left", "3px").html("");
            me.myHtml.wrapper.append(me.myHtml.wrapper.value, me.myHtml.wrapper.unit);
            me.myRoot.append(me.myHtml.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _formatNumber: function (raw) {
            if(raw === null || raw === undefined) return "--";
            if (!raw && raw !== 0) return "--";
            var parts = raw.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.length > 1 ? parts[0] + "," + parts[1] : parts[0];
        } ,
   

    _fetch: function () {
        var me = this;
        try {

            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1 }, function (result) {
                if (!result || result.length === 0) {
                    me.myHtml.wrapper.value.html("--");
                    me.myHtml.wrapper.unit.html("");
                    return;
                }
                me.myHtml.wrapper.value.html(me._formatNumber(result[0].Value));
                me.myHtml.wrapper.unit.html(result[0].Unit);
                me.myHtml.wrapper.attr("data-name", result[0].Name);
                var tooltipText = result[0].Name + (result[0].Unit ? " [" + result[0].Unit + "]" : "") + "\n" + (result[0].Timestamp || "");
                me.myHtml.wrapper.attr("title", tooltipText);
                me.myHtml.wrapper.closest(".dashboard-item").attr("title", tooltipText);

    
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _setHeightsAndWidths: function () {
        var me = this;
        try {
            if (me.error) { return false; }
            
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    /**
     * Handles error display states for the widget.
     * When an error occurs (bError=true), both the menu bar and content area are hidden,
     * leaving only the framework's error message visible to the user.
     * This ensures a clean UI when the widget cannot function due to missing data or server errors.
     *
     * Called by the framework's built-in error handling mechanism (inherited from vcBaseV4).
     *
     * @param {boolean} bError - true if an error state should be shown, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});